const baseURL = "https://api.vtmoneyafrica.com";

export default baseURL;
